import { render } from "./ConceptsWidget.vue?vue&type=template&id=13e6766a"
import script from "./ConceptsWidget.vue?vue&type=script&lang=js"
export * from "./ConceptsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__